import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';

const size = 64;

const useStyles = makeStyles(() =>
    createStyles({
        loader: {
            position: 'absolute',
            top: '40%',
            left: '50%'
        }
    })
);

export const SectionLoader: React.SFC = () => {
    const classes = useStyles({});

    return <CircularProgress size={size} className={classes.loader} />;
};

export default SectionLoader;
